// extracted by mini-css-extract-plugin
export default {"box":"Status_box__lFh6I","finalStatus":"Status_finalStatus__nIOok","boxImage":"Status_boxImage__fbxpj","boxContent":"Status_boxContent__9hYFG"};